import { Observable } from 'rxjs';
import { LocalStorageNotificationMaterialOrderModel } from '../../models/low-level/local-storage-notification-material-order.model';
import { MaterialModel, JsonMaterialModel } from '../../models/low-level/material.model';

export interface StorageMaterialInterface {
    getAllMaterialCreateOrders(): Observable<{
        material: LocalStorageNotificationMaterialOrderModel[];
        timestamp: number;
    }>;
    saveMaterialCreateOrders(
        notificationMaterialOrders: LocalStorageNotificationMaterialOrderModel[],
        timestamp?: number,
    ): Observable<void>;
    saveMaterials(materials: MaterialModel[], timestamp?: number): Observable<void>;
    getMaterials(): Observable<{ material: JsonMaterialModel[]; timestamp: number }>;
}

// Interface representing storage materials in IndexedDB
export interface StorageMaterialDbEntry {
    id: number;
    materialsblob: Uint8Array;
    timestamp: number;
}
